function archive() {
    if (!document.body.classList.contains('post-type-archive-tool')) {
        return;
    }

    const applyRequestedSort = () => {
        const requestedSort = new URLSearchParams(window.location.search).get('orderby');
        const allowedSorts = [
            'best_value',
            'editorial_score',
            'community_rating',
            'most_recommended',
            'recently_verified',
            'lowest_price',
            'free_generosity',
            'title',
            'date',
            'popularity',
            'most_saved',
        ];
        const select = document.querySelector('select[name="orderby"]');

        if (!select || !allowedSorts.includes(requestedSort) || select.value === requestedSort) {
            return;
        }

        select.value = requestedSort;

        if (window.jQuery) {
            window.jQuery(select).trigger('chosen:updated');
        }
    };

    if (document.readyState === 'complete') {
        window.setTimeout(applyRequestedSort, 50);
    } else {
        window.addEventListener('load', () => window.setTimeout(applyRequestedSort, 50), {once: true});
    }
}

export {archive};
